<template>
  <div class="type_link">
    <router-link to="/sl/settings?create=1">
      <div class="title">Создать короткую ссылку</div>
      <div class="arrow_link">
        <i class="fas fa-arrow-right"></i>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "service_8_createLink",
  data: function () {
    return {};
  },
  methods: {},
  mounted: function () {},
};
</script>